import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'

export const uiInitialState = {
  href: '',
  tab: {
    current: 'Maps'
  },
  inviteMemberDialog: {
    open: false
  }
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState: uiInitialState,
  reducers: {
    setCurrentTab: (state, action) => {
      state.tab.current = action.payload
    },
    openInviteMemberDialog: (state) => {
      state.inviteMemberDialog.open = true
    },
    closeInviteMemberDialog: (state) => {
      state.inviteMemberDialog.open = false
    }
  }
})

export const {
  setCurrentTab,
  openInviteMemberDialog,
  closeInviteMemberDialog
} = uiSlice.actions

const selectCurrentTab = (state) => state.ui.tab.current
const selectHref = (state) => state.ui.href

export const useCurrentTab = () => useSelector(selectCurrentTab)

export const useHref = () => useSelector(selectHref)

export const useInviteMemberDialog = () =>
  useSelector((state) => state.ui.inviteMemberDialog)

export default uiSlice.reducer
